module.exports = function getResource(label, vars = []) {
    let resources = {
        seeMore: 'See more',
        inTheGallery: 'in the Gallery'
    };
    return resources[label];
};
